"use client";

import Link from "next/link";
import AddToCart from "@/components/frontend/product/client/AddToCart";
import WishListButton from "@/components/frontend/wishlist/Client/WishListButton";

type Props = {
    productId: string;
    productName: string;
    price: number | null;
    quantity: number;
    selectedAttributes?: Record<string, string>;
    canOrder?: boolean;
};

const whatsappNumber = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER!;

export default function OrderSummary({
    productId,
    productName,
    price,
    quantity,
    selectedAttributes,
    canOrder = true,
}: Props) {
    if (!price) return null;

    const subtotal = price * quantity;

    const whatsappMessage = encodeURIComponent(
        `Hello Mobett's Agro Center, I'd like to order:\n\n*Item:* ${productName}\n*Quantity:* ${quantity}\n\n*Price Breakdown:*\n\n   ${quantity} × KES ${price.toLocaleString()}: KES ${subtotal.toLocaleString()}\n\n*Total: KES ${subtotal.toLocaleString()}*`
    );
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

    return (
        <div className="overflow-hidden text-sm md:mt-2">

            {/* Line item */}
            {/* <div className="flex items-center justify-between px-4 py-3 bg-gray-50">
                <span className="text-gray-600">
                    {quantity} × KES {price.toLocaleString()}
                </span>
                <span className="font-medium text-blackColor">
                    KES {subtotal.toLocaleString()}
                </span>
            </div> */}

            {/* Total */}
            {/* <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200">
                <div>
                    <p className="font-semibold text-blackColor">Total</p>
                    <p className="text-xs text-gray-400">Incl. 16% VAT</p>
                </div>
                <p className="font-semibold text-blackColor">
                    KES {subtotal.toLocaleString()}
                </p>
            </div> */}

            {/* Action buttons */}
            <div className="flex flex-col gap-2 py-0 lg:py-3 border-t border-black/50">

                {/* WhatsApp */}
                <Link
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex shrink-0 items-center justify-center gap-2 bg-green-500 text-white px-4 py-2.5 font-medium hover:bg-green-600 transition-colors"
                >
                    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 shrink-0" aria-hidden="true">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.117.549 4.103 1.508 5.83L0 24l6.335-1.48A11.934 11.934 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 01-5.006-1.37l-.36-.214-3.726.871.936-3.629-.235-.373A9.818 9.818 0 1112 21.818z"/>
                    </svg>
                    Order via WhatsApp
                </Link>

                <div className="flex w-full gap-2 md:gap-2">
                    {/* Add to Cart */}
                    {/* <AddToCart
                        productId={productId}
                        selectedAttributes={selectedAttributes}
                        quantity={quantity}
                        disabled={!canOrder}
                    /> */}

                    {/* Wishlist — selectedAttributes passed as-is (undefined is intentional) */}
                    {/* <WishListButton
                        productId={productId}
                        selectedAttributes={selectedAttributes}
                        size="lg"
                        showTooltip={true}
                        className="shrink-0"
                    /> */}
                </div>
                
            </div>
        </div>
    );
}